import FieldAllowedAttributeTypes from 'src/app/forms/fields/field-allowed-attribute-types.values';
import FieldAllowedValueClasses from 'src/app/forms/fields/field-allowed-value-classes.values';
import { FormTypes } from 'src/app/forms/forms.enum';
import { Attribute, FieldAttribute } from 'src/app/interfaces/form-and-field.interface';

export const selectSearchMetadata: Attribute[] = [
  {
    name: 'select',
    value_class_front: FieldAllowedValueClasses.SEARCH_SELECT,
    min_length: 1,
    max_length: 15,
    type_attribute: FieldAllowedAttributeTypes.SELECT,
    required: false,
    read_only: false,
    label: '',
    placeholder: 'All categories',
    security: false,
    scheme_name: FormTypes.SEARCH,
  },
];

export const selectSearchOptions: FieldAttribute = {
  elementDataTestId: 'search-select-search-element',
  id: 'select-search',
  errorDataTestId: 'search-select-search-error',
  elementStyles: {
    containerStyle: 'constructor-form-group mt-n1',
    contentStyle: 'form-control form-select',
  },
  hidden: false,
  multiple: false,
  validators: [],
  backendAttribute: {
    name: 'search',
    value_class_front: FieldAllowedValueClasses.SEARCH_SELECT,
    min_length: 1,
    max_length: 15,
    type_attribute: FieldAllowedAttributeTypes.SELECT,
    required: false,
    read_only: false,
    label: 'SEARCH_FIELDS_FILTER',
    placeholder: 'All categories',
    security: false,
    scheme_name: FormTypes.SEARCH,
  },
};
